import React, { FC } from 'react';
import './HeaderBasic.scss';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { HeaderBasicProps, DefaultProps } from './HeaderBasic.types';

const HeaderBasic: FC<HeaderBasicProps> = (props) => {
  const { children, gridHeaderClass, headerTitle, isShowButton, subTitle, headerDetails, gridChildrenProps, justifyContent="space-between" } = props;

  return (
    <>
      <Grid className={`HeaderBasic ${gridHeaderClass}`} container justifyContent={justifyContent} flexGrow={1}>
        <Grid item>
          <Typography variant="h5" fontWeight="500">{headerTitle}</Typography>
          {subTitle && (
            <Typography variant="body1" color="gray">
              {subTitle}
            </Typography>
          )}
        </Grid>
        {isShowButton && (
          <Grid item {...gridChildrenProps}>
            {children}
          </Grid>
        )}
      </Grid>
      {headerDetails && (
        <Grid className="HeaderDetails" container pb={2}>
          <Grid item xs={12} sm={7} md={5} lg={3} xl={2}>
            {headerDetails}
          </Grid>
        </Grid>
      )}
    </>
  );
};

HeaderBasic.defaultProps = DefaultProps;

export default HeaderBasic;
